import { defineStore } from 'pinia'

export const usePathsStore = defineStore('toPaths', {
  state: () => ({
    currentPaths: [],
  }),

  actions: {
    setPaths(list) {
      this.currentPaths = list
    },

    clearPaths() {
      this.currentPaths = []
    },

    getPaths() {
      return this.currentPaths
    },
  },

  // 启用持久化（可选）
  // 启用持久化：pinia-plugin-persistedstate 将自动把 state 序列化到 localStorage
  // 如果你想自定义键名或存储驱动，可在 plugin 配置中设置
  persist: true,
})
